import React from 'react'
import './noData.scss'

export default function NoData({ children, style }) {
    return(
        <div className='noData' style={style}>
            { children }
        </div>
    )
}